import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        gap: "16px",
        alignItems: "center",
        padding: "8px 0",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "start",
        },
    },
    formControl: {
        borderRadius: "2px",
        width: "250px",
        height: "41px",
        [theme.breakpoints.down("xs")]: {
            width: "100%",
        },
    },
    label: {
        fontSize: theme.typography.h4.fontSize,
        fontWeight: theme.typography.fontWeightMedium,
    },
    select: {
        padding: theme.spacing(1),
        paddingRight: "0!important",
        color: theme.palette.text.primary,
    },
    menuItem: {
        width: "250px",
        whiteSpace: "normal",
    },
    pill: {
        borderRadius: "16px",
        backgroundColor: "#E0E0E0",
        padding: "2px 12px",
    },
    activePill: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "4px",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    name: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        lineHeight: 1.2,
    },
    nameLineClamp: {
        display: "-webkit-box",
        maxHeight: 14 * 1.2 * 2,
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
    },
    icon: {
        cursor: "pointer",
        fontSize: "inherit",
        color: "inherit",
        "&:hover": {
            color: "#ffffffd1",
        },
    },
}));
